<template>
  <div class="root_wrapper">
    <div class="main_content">
      <img class="left_img" src="../assets/login-img.png" alt="左侧图片">
      <div class="login_wrapper">
        <Form class="login_form" :model="loginForm" :rules="loginRules">
          <p class="system_name">客服后台管理</p>
          <FormItem class="form_item" prop="username">
            <Input class="input_item" size="large" v-model="loginForm.username" placeholder="请输入用户名">
            <Icon type="ios-person-outline" slot="prepend"></Icon>
            </Input>
          </FormItem>
          <FormItem class="form_item password_ipt_wrapper" prop="password">
            <Input class="input_item" size="large" :type="passwordIptType" v-model="loginForm.password" placeholder="请输入密码">
              <Icon type="ios-lock-outline" slot="prepend"></Icon>
            </Input>
            <Icon :class="[passwordShow ? 'open_eye':'', 'eye_icon']" :type="eyeIcontxt" @click.native="changeEyeStatus"></Icon>
          </FormItem>
          <FormItem class="form_item" prop="captcha">
            <Input class="input_item ipt_code" size="large" v-model="loginForm.captcha" placeholder="请输入右侧验证码"/>
            <Tooltip content="看不清，点下试试" placement="top">
              <img class="code_img" :src="captcha" alt="验证码" @click="getLoginCode">
            </Tooltip>
          </FormItem>
          <FormItem class="form_item">
            <Button class="login_btn" type="primary" @click="confirmLogin">登录</Button>
          </FormItem>
        </Form>
        <div class="photo_wrapper">
          <Icon class="photo_icon" type="md-person"/>
        </div>
      </div>
    </div>
    <div class="footer_section">
      <p class="footer-info">奇初教育有限公司</p>
    </div>
  </div>
</template>
<script>
  import {Spin} from 'iview';
  import {messageAlert} from '../common/common';
  import {_getLoginCode,_confirmLogin} from '../api/api';
  export default {
    data() {
      return {
        captcha: '',// 验证码图片链接
        passwordShow:false,//密码可见状态
        eyeIcontxt: 'md-eye-off',//眼睛的显示状态
        passwordIptType:'password',
        loginForm: {
          username: '',
          password: '',
          captcha: ''
        },
        loginRules: {
          username: [
            {
              required: true,
              message: "请输入用户名"
            }
          ],
          password: [
            {
              required: true,
              message: "请输入正确的密码",
            }
          ],
          captcha: [
            {
              required:true,
              message: '请输入正确的验证码'
            }
          ]
        }
      }
    },
    methods: {
//      密码可见状态
      changeEyeStatus(){
        this.passwordShow = !this.passwordShow;
        this.passwordIptType = this.passwordShow ? 'text' : 'password';
        this.eyeIcontxt = this.passwordShow ? 'md-eye' : 'md-eye-off';
      },
      confirmLogin() {
        const self = this;
        let dataInfo = {
          "loginNo": self.loginForm.username,
          "password": self.loginForm.password,
          "token": sessionStorage.getItem("token"),
          "captcha": self.loginForm.captcha,
          "clientType": "pc",
          "clientVersion": "v2018.09.25",
          "linkInfo": ""
        };
        if(!self.loginForm.username) {
          messageAlert("请输入正确的用户名");
          return;
        }
        if(!self.loginForm.password) {
          messageAlert("密码有误，请确认密码");
          return;
        }
        if(!self.loginForm.captcha) {
          messageAlert("验证码有误，请检查");
          return;
        }
        _confirmLogin(dataInfo).then(res => {
//          self.$router.replace('/customer')
          if(res.code === 0) {
            sessionStorage.setItem("token",res.data.token);
            self.$router.replace('/customer');
          }else if(res.code === 10001){
            self.loginForm.captcha = '';
            self.getLoginCode();
          }
        })
      },
//      获取登录验证码
      getLoginCode() {
        const self = this;
        _getLoginCode().then(res => {
          if(res.code === 0) {
            self.captcha = 'data:image/' + res.data.type + ';base64,' + res.data.data;
            sessionStorage.setItem("token", res.data.token);
          }
        })
      }
    },
    mounted() {
      this.getLoginCode();
    }
  };
</script>
<style scoped>
  .root_wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    min-width: 1080px;
    min-height: 650px;
    background: #93defe;
    -webkit-background-size: cover;
    background-size: cover;
  }

  .main_content {
    flex: 1;
    display: flex;
    width: 1080px;
    margin: 100px auto 0;
  }

  .left_img {
    width: 400px;
    height: 500px;
    margin-right: 60px;
  }

  .left_img {
    flex: 1;
  }

  .login_wrapper {
    position: relative;
    flex: 0 0 360px;
    width: 360px;
    height: 400px;
    padding: 30px;
    margin-top: 50px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    background: #fff;
  }

  .photo_wrapper {
    position: absolute;
    top: -60px;
    left: 120px;
    width: 120px;
    height: 120px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    border: 5px solid #93defe;
    background: #fff;

  }

  .photo_icon {
    margin: 20px;
    font-size: 70px;
    color: #93defe;
  }

  .login_form {
    padding-top: 30px;
  }

  .system_name {
    line-height: 50px;
    font-size: 16px;
    color: #666;
    text-align: center;
  }

  .form_item {

  }

  .ipt_code {
    width: 140px;
  }

  .code_img {
    width: 145px;
    height: 36px;
    margin-left: 10px;
    vertical-align: middle;
    text-align: right;
    cursor:pointer;
  }

  .login_btn {
    width: 100%;
    font-size: 16px;
  }

  .footer_section {
    flex: 0 0 60px;
    height: 60px;
    text-align: center;
  }
  .footer-info{
    line-height:60px;
    font-size: 14px;
    color:#333;
  }
  .password_ipt_wrapper{
    position:relative;
  }
  .eye_icon{
    position:absolute;
    top:0;
    right: 0;
    padding: 8px 15px;
    font-size: 20px;
    color:#000;
    z-index:9999;
  }
  .open_eye{
    color:#2d8cf0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue